import { HttpClient } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { QueryOptions } from "@kno2/core/http";
import { filterNonEmptyProperties } from "@kno2/utils";
import { firstValueFrom, switchMap } from "rxjs";
import { RequestHistoryDocumentQuery } from "./document-query.model";

export interface QueryHistoryQueryResponse {
    items: RequestHistoryDocumentQuery[];
    totalCount: number;
}

@Injectable({
    providedIn: "root"
})
export class QueryHistoryService {
    private readonly httpClient = inject(HttpClient);

    public getQueryHistory(query: Signal<QueryOptions>): Signal<QueryHistoryQueryResponse> {
        return toSignal(
            toObservable(query).pipe(
                switchMap((params) =>
                    this.httpClient.get<QueryHistoryQueryResponse>(`/api/queryhistory`, {
                        params: { ...filterNonEmptyProperties(params) }
                    })
                )
            ),
            { initialValue: { items: [], totalCount: 0 } }
        );
    }

    public getHistoryEntry(id: string): Promise<RequestHistoryDocumentQuery> {
        return firstValueFrom(this.httpClient.get<RequestHistoryDocumentQuery>(`/api/queryhistory/${id}`));
    }

    public async removeHistoryEntry(id: string): Promise<void> {
        return firstValueFrom(this.httpClient.delete<void>(`/api/queryhistory/${id}`));
    }

    public saveQuery(documentQuery: RequestHistoryDocumentQuery): Promise<Pick<RequestHistoryDocumentQuery, "id">> {
        return firstValueFrom(this.httpClient.post<Pick<RequestHistoryDocumentQuery, "id">>("/api/queryhistory", documentQuery));
    }
}
